import { combineReducers } from 'redux'
import basicRequest from '../../../../core/redux/reducers/request'

const browse = basicRequest('ADMIN_FILE_MANAGER_BROWSE')

export default combineReducers({ browse })
